// extracted by mini-css-extract-plugin
export default {"datagrid":"RoleTable_datagrid__-He2Q","datagrid-header":"RoleTable_datagrid-header__dm989","cell-permissions":"RoleTable_cell-permissions__l81TB"};